/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-xpadding',
  templateUrl: './theme-option-tooltips-xpadding.component.html',
  styleUrls: ['./theme-option-tooltips-xpadding.component.css']
})
export class ThemeOptionTooltipsXPaddingComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_xPadding';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_xPadding', value);
  }

}
